import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { LINKEDIN_URL } from "../data/products";
import { scrollToId } from "../lib/scroll";

const goTo = (href) => scrollToId(href);

export const FinalCTA = () => {
  const reduce = useReducedMotion();
  return (
    <footer data-testid="final-cta" className="ambient border-t border-hairline">
      <div className="mx-auto max-w-5xl px-6 py-14 md:py-20 lg:px-8 text-center">
        <motion.h2
          initial={reduce ? { opacity: 0 } : { opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto max-w-2xl font-bold leading-[1.06] tracking-tight text-ink text-[clamp(2.1rem,5.2vw,3.25rem)] text-balance"
        >
          Explore what MisiDigi is building.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mx-auto mt-5 max-w-md text-[17px] leading-relaxed text-slatetx"
        >
          Explore the products MisiDigi is building.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6"
        >
          <button
            data-testid="final-view-products"
            onClick={() => goTo("#products")}
            className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-ink px-7 py-3.5 text-[15px] font-semibold text-white transition-all hover:bg-steel sm:w-auto"
          >
            View Products
            <ArrowRight
              size={16}
              className="transition-transform group-hover:translate-x-0.5"
            />
          </button>
          <a
            data-testid="final-linkedin"
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[15px] font-medium text-slatetx underline-offset-4 transition-colors hover:text-ink hover:underline"
          >
            Connect on LinkedIn
          </a>
        </motion.div>
      </div>

      {/* Footer meta */}
      <div className="border-t border-hairline">
        <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-8 sm:flex-row sm:items-end sm:justify-between md:py-10 lg:px-8">
          <div>
            <img
              src="/misidigi-logo.png"
              alt="MisiDigi Lab"
              className="h-[24px] w-auto md:h-[26px]"
            />
            <p className="mt-3 text-[13px] leading-relaxed text-slatetx">
              MisiDigi · Misi Digital Indonesia
            </p>
          </div>
          <p className="font-mono text-[12px] text-platinum">
            © 2026 MisiDigi Studio
          </p>
        </div>
      </div>
    </footer>
  );
};
